import { useContext } from "react";
import { ShipmentConfirmContextValue, ShipmentDeleteContextValue, ShipmentDetailsContextValue } from "./types";
import { ShipmentConfirmContext, ShipmentDeleteContext, ShipmentDetailsContext } from "./contexts";

// ------ SHIPMENT DETAILS ---------
export const useDetailsIndexContext = (): ShipmentDetailsContextValue => {
  const context = useContext(ShipmentDetailsContext);
  if (!context) {
    throw new Error("useDetailsContext must be used within an DetailsProvider");
  }
  return context;
};

// ------ SHIPMENT DELETE ---------
export const useShipmentDeleteContext = (): ShipmentDeleteContextValue => {
  const context = useContext(ShipmentDeleteContext);
  if (!context) {
    throw new Error(
      "useDeleteShipmentContext must be used within a DeleteShipmentProvider",
    );
  }
  return context;
};

// ------ SHIPMENT CONFIRM ---------
export const useShipmentConfirmContext = (): ShipmentConfirmContextValue => {
  const context = useContext(ShipmentConfirmContext);
  if (!context) {
    throw new Error(
      "useConfirmShipmentContext must be used within a ConfirmShipmentProvider",
    );
  }
  return context;
};
